// PAQUETES
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const CLAVE_CIERRE = "zervicy_banner_descuento_cerrado";
const DIAS_ANTES_DE_VOLVER_A_MOSTRAR = 3;

// Mismo criterio de rutas que bannerDescargarApp.jsx: se oculta en sesión, checkout/pagos,
// cuenta privada del comprador y /links. admin y vendedor quedan excluidos porque el
// componente ni se monta ahí (ver Direccionamiento.jsx).
const RUTAS_EXCLUIDAS = [
    "/iniciar-sesion", "/registrar", "/referido", "/eliminar-datos",
    "/alerta", "/error-inicio-google", "/descargar-beta", "/callback-didit",
    "/reserva", "/pago", "/respuesta-pago",
    "/links",
];

function esRutaDeExploracion(pathname){
    if(RUTAS_EXCLUIDAS.includes(pathname)) return false;
    if(pathname.startsWith("/usuario/")) return false;

    return true;
}

function fueCerradoRecientemente(){
    const guardado = window.localStorage.getItem(CLAVE_CIERRE);
    if(!guardado) return false;

    const fechaCierre = Number(guardado);
    if(Number.isNaN(fechaCierre)) return false;

    const diasTranscurridos = (Date.now() - fechaCierre) / (1000 * 60 * 60 * 24);
    return diasTranscurridos < DIAS_ANTES_DE_VOLVER_A_MOSTRAR;
}

// Sin sesión no podemos saber si es su primera compra — se muestra como mensaje genérico.
// Con sesión, se pregunta al backend (nunca se decide en el frontend) para no molestar a
// quien ya compró antes.
function BannerPrimeraCompra({ usuario }){

    const location = useLocation();
    const rutaPermitida = esRutaDeExploracion(location.pathname);

    const [visible, setVisible] = useState(false);
    // Nunca hardcodear el % — viaje siempre desde variables.js (única fuente de verdad) para no
    // tener que tocar este componente si el descuento cambia de 5% a otro valor.
    const [pct, setPct] = useState(5);
    const [montoMinimo, setMontoMinimo] = useState(100000);

    useEffect(() => {
        if(!rutaPermitida || fueCerradoRecientemente()){
            setVisible(false);
            return;
        }

        let cancelado = false;

        if(!usuario?.idUsuario){
            // Sin sesión igual consultamos el % actual (la ruta responde aunque no haya idComprador).
            axios.post("/elegible-descuento-primera-compra", { params: {} })
                .then((res) => {
                    if(cancelado) return;
                    if(res?.data?.descuentoPrimeraCompraPct) setPct(Math.round(res.data.descuentoPrimeraCompraPct * 100));
                    if(res?.data?.descuentoPrimeraCompraMontoMinimo) setMontoMinimo(res.data.descuentoPrimeraCompraMontoMinimo);
                    setVisible(true);
                })
                .catch(() => { if(!cancelado) setVisible(true); });
            return () => { cancelado = true; };
        }

        axios.post("/elegible-descuento-primera-compra", { params: { idComprador: usuario.idUsuario } })
            .then((res) => {
                if(cancelado) return;
                if(res?.data?.descuentoPrimeraCompraPct) setPct(Math.round(res.data.descuentoPrimeraCompraPct * 100));
                if(res?.data?.descuentoPrimeraCompraMontoMinimo) setMontoMinimo(res.data.descuentoPrimeraCompraMontoMinimo);
                setVisible(res?.data?.elegible === true);
            })
            .catch(() => { if(!cancelado) setVisible(false); });

        return () => { cancelado = true; };
    }, [rutaPermitida, usuario?.idUsuario]);

    function cerrarBanner(){
        window.localStorage.setItem(CLAVE_CIERRE, String(Date.now()));
        setVisible(false);
    }

    if(!visible) return null;

    return (
        <div
            className="d-flex align-items-center justify-content-center gap-2 px-5 py-2 position-relative"
            style={{ backgroundColor: "var(--verde-esmeralda)", color: "white" }}
        >
            <i className="bi bi-gift-fill flex-shrink-0" style={{ fontSize: "18px" }} />

            <div className="text-start" style={{ minWidth: 0 }}>
                <p className="fw-bold mb-0 text-truncate" style={{ fontSize: "13px" }}>
                    ¿Primera compra? Tienes {pct}% de descuento
                </p>
                <p className="mb-0 text-truncate" style={{ fontSize: "12px", opacity: 0.9 }}>
                    En servicios de más de ${montoMinimo.toLocaleString("es-CO")} — se aplica automáticamente al pagar
                </p>
            </div>

            <button
                type="button"
                className="btn btn-link p-0 position-absolute"
                onClick={cerrarBanner}
                aria-label="Cerrar"
                title="Cerrar"
                style={{ textDecoration: "none", fontSize: "18px", color: "white", right: "16px" }}
            >
                <i className="bi bi-x-lg" />
            </button>
        </div>
    );
}

export default BannerPrimeraCompra;
